import React from 'react'
import { Helmet } from 'react-helmet-async'
import Landing from './Landing'
import Text from './Text'

const Resources = () => {
  return (
    <>
      <Helmet>
        <title>ESG Standards, Frameworks & Sustainability Resources | Nirantara</title>
        <meta name="description" content="Access key ESG frameworks and sustainability resources, including GRI, BRSR, CDP, TCFD, SASB, and more. Nirantara helps you navigate and apply the right standards for your reporting and compliance needs." />
        <meta name="keywords" content="ESG resources, sustainability frameworks, GRI standards guide, BRSR SEBI format, CDP reporting resources, TCFD framework guide, SASB standards, ESG compliance resources, sustainability reporting standards" />
        <link rel="canonical" href="https://nirantara.solutions/resources" />
      </Helmet>
      <div className="w-full md:mb-20 mb-8 flex flex-col items-center gap-8  montserrat ">
        <Landing />
        <Text />
      </div>
    </>
  )
}

export default Resources